import styles from "../EventSubmissionForm/EventSubmissionForm.module.scss";
import i18n from "../../i18n";
import PropTypes from "prop-types";
import {Form, Formik} from "formik";
import InputGroup from "../InputGroup";
import {InputGroupV2, PrevAndSubmitButtons} from "./EventSubmissionFormV2";

const ContactStep = ({
                       initialValues,
                       validationSchema,
                       onSubmit,
                       consentText,
                       onClickPrev
                   }) => {
    // Open the privacy policy in new window, so we don't lose state when pressing back button
    // also add an icon to indicate that the link will open in new tab
    consentText = consentText.replace(
        ' href',
        ' class=' +
        styles['EventSubmissionForm__ConsentLink'] +
        ' target="_blank" rel="noopener noreferrer" href'
    );

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
        >{() => (
            <Form className={styles['EventSubmissionForm--V2']}>
                <fieldset
                    className={
                        styles['EventSubmissionForm__Section']
                    }
                >
                    <legend
                        className={
                            styles[
                                'EventSubmissionForm__SectionHeader'
                                ] +
                            ' ' +
                            styles[
                                'EventSubmissionForm__SectionHeader--Required'
                                ]
                        }
                    >
                        {i18n.t(
                            'EventSubmissionForm.sectionHeaderSubmittedBy'
                        )}
                    </legend>
                    <InputGroupV2
                        name="externalWebsiteUrl"
                        placeholder={i18n.t(
                            'EventSubmissionForm.labels.websiteUrl'
                        )}
                        type="text"
                        infoMessage=""
                    />
                    <InputGroupV2
                        name="submittedByEmail"
                        placeholder={i18n.t(
                            'EventSubmissionForm.labels.submittedByEmail'
                        )}
                        type="email"
                        autoComplete="email"
                    />
                    <InputGroup
                        name="consent"
                        type="checkbox"
                        items={[
                            {
                                value: 'consent',
                                label:
                                    consentText ||
                                    i18n.t(
                                        'EventSubmissionForm.labels.consent'
                                    ),
                            },
                        ]}
                    />
                </fieldset>
                <PrevAndSubmitButtons onClickPrev={onClickPrev}/>
            </Form>
        )}
        </Formik>
    )
}

export default ContactStep;
